import { Dropdown } from "react-bootstrap";

import {  Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem } from "../../components";
import { MdDelete } from "react-icons/md";

import { handleDeleteState } from "../../pages/states-manage/StatesList"
import { createPortal } from "react-dom"
export const userColumns = ({ setStatesData }) => {
    return [
        {
            name: "State ID",
            selector: (row) => row.zone_id,
            cell: (row) => (
                <span>{row.zone_id}</span>
            ),
            sortable: true,
        },

        {
            name: "State Name",
            selector: (row) => row.name,
            cell: (row) => (
             
                        <span className="small text" style={{ whiteSpace: "nowrap" }}>
                            {row.name}
                        </span>
                 


            ),
            sortable: true,
            minWidth: "150px",
        },
       
        {
            name: "Country",
            selector: (row) => row.WebtagCountry?.name,
            cell: (row) => (
             
                        <span className="small text" style={{ whiteSpace: "nowrap" }}>
                            {row.WebtagCountry?.name}
                        </span>
                 


            ),
            sortable: true,
            minWidth: "150px",
        },
        {
            name: "CODE",
            selector: (row) => row.code,
            cell: (row) => (
             
                        <span className="small text" style={{ whiteSpace: "nowrap" }}>
                            {row.code}
                        </span>
                 


            ),
            sortable: true,
            minWidth: "150px",
        },
        {
            name: "action",
            cell: (row) => (
                <div className="text-end w-100">
                    <Dropdown>
                        <Dropdown.Toggle size="sm" as={CustomDropdownToggle} className="btn btn-sm btn-icon btn-zoom me-n1">
                            <Icon name="more-v"></Icon>
                        </Dropdown.Toggle>
                        {createPortal(

                        <Dropdown.Menu className="dropdown-menu-sm" as={CustomDropdownMenu} align="end">
                            <div className="dropdown-content py-1">
                                <LinkList className="link-list-hover-bg-primary link-list-md">
                                    <LinkListItem to={`/states-manage/states-list/${row.zone_id}`}>
                                        <Icon name="edit"></Icon><span>Edit</span>
                                    </LinkListItem>
                                 
                                    <LinkListItem  className="delete-ittem" to="#" onClick={() => handleDeleteState(row.zone_id, setStatesData)}>
                                    <MdDelete/><span>Delete</span>
                                    </LinkListItem>
                                </LinkList>
                            </div>
                        </Dropdown.Menu>
                         ,
                         document.body
                     )}
                    </Dropdown>
                </div>
            ),
            sortable: false,

        },
    ]
};


